import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import { positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { BrowserRouter } from "react-router-dom";

const options = {
  timeout: 5000,
  offset: "20px",
  position: positions.BOTTOM_CENTER,
  containerStyle: {
    zIndex: 10000000,
  },
};

ReactDOM.render(
  <BrowserRouter>
    <AlertProvider template={AlertTemplate} {...options}>
      <App />
      {/* <McqCard/> */}
    </AlertProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
